export interface Lead {
  id: string
  name: string
  phone: string
  zone: string
  type:
    | 'Tarima flotante'
    | 'Parquet de madera'
    | 'Vinílico / SPC'
    | 'Sin definir'
  m2: string
  value: number
  src: 'Meta Ads' | 'Recomendación' | 'Google' | 'Otro'
  next: string
  notes: string
  stage: 'new' | 'qual' | 'cita' | 'pres' | 'win'
  created: string
}

export interface Stage {
  id: 'new' | 'qual' | 'cita' | 'pres' | 'win'
  name: string
  short: string
  dot: string
}

export const STAGES: Stage[] = [
  { id: 'new', name: 'Nuevo', short: 'Nuevo', dot: 'bg-blue' },
  { id: 'qual', name: 'Cualificado', short: 'Cualif.', dot: 'bg-amber' },
  { id: 'cita', name: 'Cita agendada', short: 'Cita', dot: 'bg-wood' },
  { id: 'pres', name: 'Presupuestado', short: 'Presup.', dot: 'bg-purple' },
  { id: 'win', name: 'Ganada', short: 'Ganada', dot: 'bg-green' },
]
